import angular from 'angular';
import ngMessages from 'angular-messages';
import uiMask from 'angular-ui-mask';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import translate from 'angular-translate';
import translateFillLoader from 'angular-translate-loader-static-files';
import jwt from 'angular-jwt';
import 'angular-local-storage';
import 'angular-component';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import runBlock from './app.runBlock.js';
import configBlock from './app.configBlock.js';
import config from './app.config.js';
import 'normalize.css';
import fileUpload from 'ng-file-upload';
import 'checklist-model';
import 'ng-idle';
import 'bootstrap-switch';
import 'angular-bootstrap-switch';
import 'angular-sanitize';
import 'angular-cookies';
import ChatScript from './constants/chatScript';

angular.module('app', [
  ngMessages,
  uiMask,
  uiRouter,
  uiBootstrap,
  translate,
  translateFillLoader,
  'frapontillo.bootstrap-switch',
  'checklist-model',
  jwt,
  fileUpload,
  'LocalStorageModule',
  Common.name,
  Components.name,
  'ngIdle',
  'ngSanitize',
  'ngCookies'
])
  .component('app', AppComponent)
  .value('config', config)
  .constant('chatScript', ChatScript)
  .config(configBlock)
  .run(runBlock);



// WEBPACK FOOTER //
// ./app/app.js